import { Loader2, Plus, RefreshCw } from "lucide-react";

import { Button } from "@/common/ui/button";

interface WaitlistToolbarProps {
  isLoading: boolean;
  lastRefreshedAt: Date | null;
  onRefresh: () => void;
  showAddForm: boolean;
  onToggleAddForm: () => void;
}

function formatLastRefreshed(date: Date | null): string {
  if (!date) return "";
  return `Updated ${date.toLocaleTimeString()}`;
}

export function WaitlistToolbar({
  isLoading,
  lastRefreshedAt,
  onRefresh,
  showAddForm,
  onToggleAddForm,
}: WaitlistToolbarProps): React.ReactElement {
  return (
    <div data-testid="waitlist-toolbar" className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        {lastRefreshedAt && (
          <span data-testid="last-refreshed" className="text-sm text-muted-foreground">
            {formatLastRefreshed(lastRefreshedAt)}
          </span>
        )}
      </div>
      <div className="flex items-center gap-2">
        <Button
          data-testid="refresh-button"
          variant="outline"
          size="sm"
          onClick={onRefresh}
          disabled={isLoading}
        >
          {isLoading ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <RefreshCw className="h-4 w-4" />
          )}
          Refresh
        </Button>
        <Button data-testid="add-email-button" size="sm" onClick={onToggleAddForm}>
          <Plus className="h-4 w-4" />
          {showAddForm ? "Cancel" : "Add Email"}
        </Button>
      </div>
    </div>
  );
}
